import { useSetAtom, useAtomValue } from "jotai";
import {
  drawerInfoAtom,
  setDrawerInfoAtom,
  clearDrawerInfoAtom,
  isDrawerOpenAtom,
  setDrawerOpenAtom,
  isFirstItemAtom,
  isLastItemAtom,
  setIsFirstItemAtom,
  setIsLastItemAtom,
  isNextPrevEnabledAtom,
  setIsNextPrevEnabledAtom,
  viewerDocumentAtom,
  setViewerDocumentAtom,
  clearViewerDocumentsAtom,
  setIsDocumentViewerOpenAtom,
  isDocumentViewerOpenAtom,
  hasAnyUnsavedChangesAtom,
  setHasAnyUnsavedChangesAtom,
  setCurrentExpandedDeductionIdAtom,
  currentExpandedDeductionIdAtom,
  clearCurrentExpandedDeductionIdAtom,
  setCloseDocumentViewerAtom,
  selectedTabAtom,
  setSelectedTabAtom,
  isDrawerModalAtom,
  clearIsDrawerModalAtom,
  setIsDrawerModalAtom,
} from "@/store/deduction/drawer";
import {
  deductionsAtom,
  countAtom,
  isLoadingAtom,
  errorAtom,
  setRemittanceItemIdAtom,
  getDeductionsAtom,
  isDetailsUpdatingAtom,
  isIntelligenceUpdatingAtom,
  isChargeBreakdownUpdatingAtom,
  setDeductionsLoadingAtom,
} from "@/store/deduction/deduction";
import { distributionCentersAtom, getDistributionCentersAtom } from "@/store/lookup";
import { groupByCheckAtom, setGroupByCheckAtom } from "@/store/deduction/main";
  
export function useDeductionDrawer() {
  const groupByCheck = useAtomValue(groupByCheckAtom);
  const drawerInfo = useAtomValue(drawerInfoAtom);
  const setDrawerInfo = useSetAtom(setDrawerInfoAtom);
  const clearDrawerInfo = useSetAtom(clearDrawerInfoAtom);
  const isDrawerOpen = useAtomValue(isDrawerOpenAtom);
  const setDrawerOpen = useSetAtom(setDrawerOpenAtom);
  const isFirstItem = useAtomValue(isFirstItemAtom);
  const isLastItem = useAtomValue(isLastItemAtom);
  const setIsFirstItem = useSetAtom(setIsFirstItemAtom);
  const setIsLastItem = useSetAtom(setIsLastItemAtom);
  const isNextPrevEnabled = useAtomValue(isNextPrevEnabledAtom);
  const setIsNextPrevEnabled = useSetAtom(setIsNextPrevEnabledAtom);
  const hasAnyUnsavedChanges = useAtomValue(hasAnyUnsavedChangesAtom);
  const selectedTab = useAtomValue(selectedTabAtom);
  const setSelectedTab = useSetAtom(setSelectedTabAtom);
  const isDrawerModal = useAtomValue(isDrawerModalAtom);
  const setIsDrawerModal = useSetAtom(setIsDrawerModalAtom);
  const clearIsDrawerModal = useSetAtom(clearIsDrawerModalAtom);

  // Deduction atoms
  const deductions = useAtomValue(deductionsAtom);
  const deductionsCount = useAtomValue(countAtom);
  const isDeductionsLoading = useAtomValue(isLoadingAtom);
  const isDeductionsDetailsUpdating = useAtomValue(isDetailsUpdatingAtom);
  const isDeductionsIntelligenceUpdating = useAtomValue(isIntelligenceUpdatingAtom);
  const isDeductionsChargeBreakdownUpdating = useAtomValue(isChargeBreakdownUpdatingAtom);
  const deductionsError = useAtomValue(errorAtom);

  const setDeductionsLoading = useSetAtom(setDeductionsLoadingAtom);

  const setGroupByCheck = useSetAtom(setGroupByCheckAtom);

  const setRemittanceItemId = useSetAtom(setRemittanceItemIdAtom);
  const getDeductions = useSetAtom(getDeductionsAtom);

  const viewerDocuments = useAtomValue(viewerDocumentAtom);
  const setViewerDocuments = useSetAtom(setViewerDocumentAtom);
  const clearViewerDocuments = useSetAtom(clearViewerDocumentsAtom);
  const isDocumentViewerOpen = useAtomValue(isDocumentViewerOpenAtom);
  const setIsDocumentViewerOpen = useSetAtom(setIsDocumentViewerOpenAtom);
  const setCloseDocumentViewer = useSetAtom(setCloseDocumentViewerAtom);

  const getDistributionCenters = useSetAtom(getDistributionCentersAtom);
  const distributionCenters = useAtomValue(distributionCentersAtom);

  const setHasAnyUnsavedChanges = useSetAtom(setHasAnyUnsavedChangesAtom);

  const currentExpandedDeductionId = useAtomValue(currentExpandedDeductionIdAtom);
  const setCurrentExpandedDeductionId = useSetAtom(setCurrentExpandedDeductionIdAtom);
  const clearCurrentExpandedDeductionId = useSetAtom(clearCurrentExpandedDeductionIdAtom);

  return {
    groupByCheck,
    setGroupByCheck,
    // Drawer atoms
    drawerInfo,
    setDrawerInfo,
    clearDrawerInfo,
    isDrawerOpen,
    setDrawerOpen,
    isFirstItem,
    isLastItem,
    setIsFirstItem,
    setIsLastItem,
    // Deduction atoms
    deductions,
    deductionsCount,
    isDeductionsLoading,
    isDeductionsDetailsUpdating,
    isDeductionsIntelligenceUpdating,
    isDeductionsChargeBreakdownUpdating,
    deductionsError,
    setDeductionsLoading,
    setRemittanceItemId,
    getDeductions,
    isNextPrevEnabled,
    setIsNextPrevEnabled,
    // Viewer document
    viewerDocuments,
    setViewerDocuments,
    clearViewerDocuments,
    isDocumentViewerOpen,
    setIsDocumentViewerOpen,
    setCloseDocumentViewer,
    // Distribution centers
    getDistributionCenters,
    distributionCenters,
    // Has any unsaved changes
    hasAnyUnsavedChanges,
    setHasAnyUnsavedChanges,
    // Current expanded deduction id
    currentExpandedDeductionId,
    setCurrentExpandedDeductionId,
    clearCurrentExpandedDeductionId,
    // Selected tab
    selectedTab,
    setSelectedTab,
    // Is drawer inside modal
    isDrawerModal,
    setIsDrawerModal,
    clearIsDrawerModal,
  };
}
